import Promise from 'promise';
import {toastr} from 'react-redux-toastr';

import { axios, SVCMessage } from '../_helpers';

export const AdminUserService = {
    getAdminUsers,
    addAdminUser,
    editAdminUser,
    deleteAdminUser
}

function getAdminUsers() {
    return new Promise(function (resolve, reject) {
        axios.post('getAdminUsers').then((res) => {
            if (res.isSuccess) {
                resolve(res.data);
            } else {
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function addAdminUser(param) {
    return new Promise(function (resolve, reject) {
        axios.post('addAdminUsers', param).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function editAdminUser(param) {
    return new Promise(function (resolve, reject) {
        axios.post('editAdminUsers', param).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function deleteAdminUser(param) {
    return new Promise(function (resolve, reject) {
        axios.post('deleteAdminUsers', param).then((res) => {
            if (res.isSuccess) {
                toastr.success(SVCMessage[res.message]);
                resolve(res.data);
            } else {
                toastr.error(SVCMessage[res.message]);
                reject(res.message);
            }
        }).catch(error => { 
            reject(error.message);
        });
    });
};


// WEBPACK FOOTER //
// ./src/_services/admin-user.service.js